import { Box } from "@mui/material";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import BriaTooltip from "../../../../components/common/BriaTooltip/BriaTooltip";
import styles from "./FiboConfigTabs.module.scss";

type FiboConfigTabsProps = {
	activeTab: "generate" | "refine";
	setActiveTab: (tab: "generate" | "refine") => void;
	isRefineTabEnabled: boolean;
};

const FiboConfigTabs = ({ activeTab, setActiveTab, isRefineTabEnabled }: FiboConfigTabsProps) => {
	const { t } = useTranslation("fibo", { keyPrefix: "lab" });

	return (
		<Box className={styles.tabsContainer}>
			<BriaTooltip title={t("tabs.generate.tooltip")} placement="top">
				<Box
					className={clsx([styles.tabContainer, activeTab === "generate" && styles.active])}
					onClick={() => setActiveTab("generate")}
				>
					<h3 className={activeTab === "generate" ? styles.boldText : ""}>{t("tabs.generate.button")}</h3>
					{activeTab === "generate" && <div />}
				</Box>
			</BriaTooltip>

			<BriaTooltip
				title={isRefineTabEnabled ? t("tabs.refine.tooltip") : t("tabs.refine.disabledTooltip")}
				placement="top"
			>
				<Box
					className={clsx([
						styles.tabContainer,
						activeTab === "refine" && styles.active,
						!isRefineTabEnabled && styles.disabled,
					])}
					onClick={() => setActiveTab("refine")}
				>
					<h3 className={activeTab === "refine" ? styles.boldText : ""}>{t("tabs.refine.button")}</h3>
					{activeTab === "refine" && <div />}
				</Box>
			</BriaTooltip>
		</Box>
	);
};

export default observer(FiboConfigTabs);
